/**
 * Tenant Routes
 *
 * Route definitions for the tenants module.
 */

import { lazy } from 'react';

const TenantsManagement = lazy(() => import('./TenantsManagement'));
const TenantDetailView = lazy(() => import('./TenantDetailView'));

export const tenantRoutes = [
    {
        path: 'tenants',
        element: <TenantsManagement />,
    },
    {
        path: 'tenants/:id',
        element: <TenantDetailView />,
    },
];
